module.exports = __webpack_public_path__ + "static/media/settings (2).a543143a.png";